import React from "react";

import { CompanyInfoStyles } from "pages/RosterStatusPage/styled";

import { XOutlineRegularIcon } from "assets/SVGComponents";

import Input from "components/Input/index";
import Textarea from "components/TextArea/index";
import Select from "components/Select/index";
import Button from "components/Buttons";

const CompanyTabs = ({
  formData,
  handleInputChange,
  handleSelectChange,
  dropdownOptions,
  handleClearSearch,
  handleFileChange
}) => {
  return (
    <CompanyInfoStyles>
      {/* --- Row 1 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Input
            id="company-name"
            label="Company Name"
            placeholder="Enter Company Name"
            value={formData?.company_name}
            onChange={handleInputChange("company_name")}
            size="M"
          />
          <Select
            id="company-type"
            label="Type"
            value={formData?.type}
            onChange={handleSelectChange("type")}
            placeholder="Select Type"
            options={dropdownOptions.types}
          />
        </div>
        <Textarea
          id="description"
          label="Description"
          placeholder="Enter company description"
          size="M"
          className="text-area-wrapper"
          value={formData?.description}
          onChange={handleInputChange("description")}
        />
      </div>

      {/* --- Row 2 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Select
            id="size"
            label="Company Size"
            value={formData?.size}
            onChange={handleSelectChange("size")}
            placeholder="Select Size"
            options={dropdownOptions.sizes}
          />
        </div>
        <div className="text-area-wrapper">
          <Input
            id="website"
            label="Website"
            placeholder="Enter Website Link"
            value={formData?.website}
            onChange={handleInputChange("website")}
            size="M"
          />
        </div>
      </div>

      {/* --- Row 3 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers company-logo">
          <Input
            id="company-logo"
            label="Company Logo"
            readOnly
            accept="image/*"
            placeholder="Browse File"
            value={formData?.logoName || formData?.logo}
            onChange={handleInputChange("logo")}
            size="M"
            leftClass="logo-preview-wrapper"
            leftIcon={
              formData?.logoPreview || formData?.logo ? (
                <img
                  src={formData?.logoPreview || formData?.logo}
                  alt="logo-preview"
                />
              ) : null
            }
            // handleClearSearch={() => handleClearSearch("logo")}
            disabled
          />

          <input
            type="file"
            id="file-input"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          <Button
            size="M"
            variant="primary"
            onClick={() => document.getElementById("file-input").click()}
          >
            {formData?.logoPreview ? "Re-Upload" : "Browse File"}
          </Button>
        </div>

        <div className="text-area-wrapper">
          <Select
            id="services"
            label="Company Services"
            value={formData?.services}
            onChange={handleSelectChange("services")}
            placeholder="Select Options"
            options={dropdownOptions.companyServices}
            isMulti={true}
          />
        </div>
      </div>

      {/* --- Row 4 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Select
            id="specialized-region"
            label="Specialized Region"
            value={formData?.specialized_regions}
            onChange={handleSelectChange("specialized_regions")}
            placeholder="Select Region"
            options={dropdownOptions.specializedRegions}
            size="M"
            isMulti={true}
          />
        </div>
      </div>
    </CompanyInfoStyles>
  );
};

export default CompanyTabs;
